const setThumbHeight = () => {
  jQuery('.product-preview').each(function() {
    const thumbWrapper = jQuery(this).find(
      '.product-preview__thumbnail-wrapper'
    )
    const thumb = jQuery(this).find('.product-preview__thumbnail')

    if (thumb.height() < thumbWrapper.height()) {
      thumb.css({
        maxWidth: 'unset',
        width: 'auto',
        height: '100%',
      })
    } else {
      thumb.css({
        width: '100%',
        height: 'auto',
      })
    }
  })
}

jQuery(window).on('resize', setThumbHeight)

export default setThumbHeight
